import { render, staticRenderFns } from "./communicationTypeDetailReport.vue?vue&type=template&id=107e3235"
import script from "./communicationTypeDetailReport.vue?vue&type=script&lang=js"
export * from "./communicationTypeDetailReport.vue?vue&type=script&lang=js"
import style0 from "./communicationTypeDetailReport.vue?vue&type=style&index=0&id=107e3235&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports